import { Box, styled } from "@mui/material";

export const customModalStyles = {
    backdrop: {
        backgroundColor: 'transparent',
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    }
}
export const ModalBox = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    border: "1px solid black",
    borderRadius: "50px",
    width: "400px",
    height: "200x",
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    paddingBottom: theme.spacing(5),
    backgroundColor: "white",
}));

  